<template>
    <div class="main-block request-management">
        <Breadcrumbs :isCheck="true" @navigate="handleNavigation" />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.UpdateInsights') }}</h4>
        </div>
        <section class="col-12 mx-auto align-self-md-center">
            <div class="half-design row">
                <div class="col-12 form-block">
                    <div class="col-12 col-md-6 col-lg-5 mx-auto pt-5">
                        <b-form @submit.prevent="onSubmit">
                            <div class="assistant-dropdown-container mb-2">
                                <label class="dropdown-label">{{ $t('title.aiIndex') }}:</label>
                                <select v-model="formFields.index_name" class="form-control assistant-dropdown">
                                    <option value="automatic">{{ $t('title.automatic') }}</option>
                                    <option value="rakoon_sap">{{ $t('title.rakoonSap') }}</option>
                                    <option value="rakoon_salesforse_monday">{{ $t('title.rakoonSalesforceMonday') }}</option>
                                    <option value="rakoon_office_gsuit">{{ $t('title.rakoonOfficeGsuite') }}</option>
                                    <option value="rakoon_notion">{{ $t('title.rakoonNotion') }}</option>
                                </select>
                            </div>
                            <div class="mb-3 text-left">
                                <label class="mb-1" :class="serviceState" for="typeSelect">{{
                                    $t('title.SelectFrequency') }}</label>
                                <v-select id="type-select" v-model="formFields.typeSelect" :options="serviceOptions"
                                    size="sm" :placeholder="formFields.typeSelect.label">
                                </v-select>
                                <b-form-invalid-feedback :state="!formErrors.has('typeSelect')">
                                    {{ formErrors.first('typeSelect') }}
                                </b-form-invalid-feedback>
                            </div>

                            <div class="mb-3 text-left">
                                <label for="name" class="mb-1" :class="nameState">{{
                                    $t('title.EnterTaskName') }}</label>
                                <b-form-input id="name" name="name" type="text" v-model="formFields.name"
                                    @input="validateName" :class="nameState"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('name')">
                                    {{ formErrors.first('name') }}
                                </b-form-invalid-feedback>
                                <!-- Show error message -->
                            </div>

                            <div class="mb-3 text-left">
                                <label for="description" class="mb-1" :class="descriptionState">
                                    {{ $t('title.EnterTaskdescription') }}
                                </label>

                                <b-form-textarea id="description" v-model="formFields.description"
                                    @input="validateDescription" :placeholder="$t('title.EnterTaskdescription')"
                                    :class="descriptionState" rows="6" max-rows="16"></b-form-textarea>

                                <b-form-invalid-feedback :state="!formErrors.has('description')">
                                    {{ formErrors.first('description') }}
                                </b-form-invalid-feedback>
                                <div class="d-flex mt-2">
                                    <b-button type="button" variant="info" class="mr-2" @click="evaluateInsight"
                                        :disabled="!formFields.description || isEvaluating">
                                        <span v-if="isEvaluating">{{ $t('title.evaluating') }}</span>
                                        <span v-else>{{ $t('title.evaluateInsight') }}</span>
                                    </b-button>
                                    <span v-if="userScore" class=" text-success ml-auto" style="font-size: 0.85em;">{{
                                        userScore }}/10</span>
                                </div>
                            </div>

                            <div v-if="showSuggestion" class="row mb-3 align-items-stretch">
                                <div class="col-12 mt-2" v-if="suggestions && suggestions.length">
                                    <div class="card border-info">
                                        <div class="card-header py-2 px-3 bg-info text-white d-flex align-items-center">
                                            <i class="bi bi-list-check mr-1"></i>
                                            <span class="font-weight-bold ml-1">{{ $t('title.suggestionsToImprove') }}</span>
                                        </div>
                                        <div class="card-body py-2 px-3">
                                            <ul class="mb-0 pl-3">
                                                <li v-for="(s, i) in suggestions" :key="i">{{ s }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-12 mt-2">
                                    <div class="card h-100 border-success" style="font-size: 0.95rem;">
                                        <div
                                            class="card-header py-2 px-3 bg-success text-white d-flex align-items-center">
                                            <i class="bi bi-lightbulb-fill mr-1 text-warning"
                                                style="font-size: 1.1rem;"></i>
                                            <span class="font-weight-bold ml-1">{{ $t('title.improvedPrompt') }}</span>
                                            <span class="badge badge-light text-success ml-auto"
                                                style="font-size: 0.85em;">{{ suggestedScore }}/10</span>
                                        </div>
                                        <div class="card-body py-2 px-3">
                                            <b-form-textarea v-model="suggestedInsight" rows="5"
                                                class="border border-success"
                                                style="font-size: 0.95em;"></b-form-textarea>
                                        </div>
                                        <center>
                                            <b-button size="sm" variant="success" @click="acceptSuggestion"
                                                class="w-50 mb-2">
                                                <i class="bi bi-check-circle mr-1"></i>{{ $t('title.yesUpdateIt') }}
                                            </b-button>
                                        </center>
                                    </div>

                                </div>
                                <!-- Suggestions & Guidance -->

                            </div>
                            <div class="mb-3 text-left">
                                <label for="start_time" class="mb-1 d-block" :class="startTimeState">
                                    {{ $t('title.EnterStartTime') }}
                                </label>
                                <div class="timepicker-wrapper">
                                    <b-form-timepicker id="start_time" v-model="formFields.start_time" now-button
                                        reset-button locale="en" minute-step="5" format="H:i" required class="w-100">
                                    </b-form-timepicker>
                                </div>
                                <b-form-invalid-feedback :state="!formErrors.has('start_time')">
                                    {{ formErrors.first('start_time') }}
                                </b-form-invalid-feedback>
                            </div>

                            <!-- End Time -->
                            <div class="mb-3 text-left">
                                <label for="end_time" class="mb-1" :class="endTimeState">
                                    {{ $t('title.EnterEndTime') }}
                                </label>
                                <div class="timepicker-wrapper">
                                    <b-form-timepicker id="end_time" v-model="formFields.end_time" now-button
                                        reset-button locale="en" minute-step="5" format="H:i"
                                        :disabled="endTimeDisabled" @input="validateEndTime" class="w-100">
                                    </b-form-timepicker>

                                </div>
                                <b-form-invalid-feedback :state="!formErrors.has('end_time')">
                                    {{ formErrors.first('end_time') }}
                                </b-form-invalid-feedback>
                            </div>


                            <div class="mb-3 text-left">
                                <label for="email" name="email" class="mb-1" :class="emailState">
                                    {{ $t('title.EnterEmail') }}
                                </label>
                                <b-form-input id="email" type="email" v-model="formFields.email" @input="validateEmail"
                                    :class="emailState" name="email"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('email')">
                                    {{ formErrors.first('email') }}
                                </b-form-invalid-feedback>
                            </div>

                            <div class="mb-3 text-left">
                                <label for="status" class="mb-1" :class="statusState">
                                    {{ $t('title.SelectStatus') }}
                                </label>
                                <v-select id="status" v-model="formFields.status" :class="statusState"
                                    :options="statusOptions" size="sm" required></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('status')">
                                    {{ formErrors.first('status') }}
                                </b-form-invalid-feedback>
                            </div>

                            <b-button type="submit" variant="primary" class="mb-3 w-100" :disabled="loader">
                                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader">
                                </div>
                                {{ $t('title.Submit') }}
                            </b-button>

                            <div class="d-flex gap-2">
                                <b-button type="button" variant="secondary" class="mb-3 col" @click.prevent="resetForm">
                                    {{ $t('title.clear') }}
                                </b-button>
                                <b-button type="button" variant="danger" class="mb-3 col" @click.prevent="onCancel">
                                    {{ $t('title.cancel') }}
                                </b-button>
                            </div>

                            <b-form-invalid-feedback v-if="formErrors.general">{{ formErrors.general
                                }}</b-form-invalid-feedback>
                        </b-form>
                    </div>
                </div>
            </div>
            <InputChangeConfirmationModal ref="inputChangeConfirmationModal" @back="goBackToDestination" />
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import InputChangeConfirmationModal from "../modal/InputChangeConfirmationModal";

export default {
    data() {
        return {
            formFields: reactive({
                name: '',
                typeSelect: '',
                description: '',
                start_time: '',
                end_time: '',
                email: '',
                status: '',
            }),
            serviceOptions: [
                { label: this.$t('title.Daily'), value: 'D' },
                { label: this.$t('title.Hourly'), value: 'H' },
            ],
            statusOptions: [
                { label: this.$t('title.Active'), value: '1' },
                { label: this.$t('title.Inactive'), value: '0' },
            ],
            formErrors: new Error({}),
            endTimeDisabled: false,
            originalForm: {},
            isFormDirty: false,
            nextRoute: '',
            userInsight: '',
            userScore: null,
            suggestedInsight: '',
            suggestedScore: null,
            finalInsight: '',
            showSuggestion: false,
            isEvaluating: false,
            suggestions: [],
        };
    },
    components: { Breadcrumbs, InputChangeConfirmationModal },
    computed: {
        ...mapGetters(['loader']),
        nameState() {
            return this.formFields.name === '' ? '' : this.formErrors.name ? 'is-invalid' : 'is-valid';
        },
        statusState() {
            return this.formFields.status === null ? '' : this.formErrors.status ? 'is-invalid' : 'is-valid'; // Add computed for status
        },

        descriptionState() {
            return this.formFields.description === '' ? '' : this.formErrors.description ? 'is-invalid' : 'is-valid';
        },

        startTimeState() {
            return this.formFields.start_time === '' ? '' : this.formErrors.start_time ? 'is-invalid' : 'is-valid';
        },

        endTimeState() {
            return this.formFields.end_time === '' ? '' : this.formErrors.end_time ? 'is-invalid' : 'is-valid';
        },

        emailState() {
            return this.formFields.email === '' ? '' : this.formErrors.email ? 'is-invalid' : 'is-valid';
        },
        serviceState() {
            return this.formFields.typeSelect === '' ? '' : this.formErrors.typeSelect ? 'is-invalid' : 'is-valid';
        },
    },

    methods: {
        goBackToDestination() {
            if (this.nextRoute) {
                this.$router.push(this.nextRoute);
            }
        },
        handleNavigation(crumb) {
            if (this.isFormDirty) {
                this.$refs['inputChangeConfirmationModal'].handleToggleModal();
                this.nextRoute = crumb.path; // Store next route
            } else {
                this.$router.push(crumb.path); // Navigate if no unsaved changes
            }
        },
        markAsDirty() {
            this.isFormDirty = true;
        },
        checkForChanges() {
            this.isFormDirty = JSON.stringify(this.formFields) !== JSON.stringify(this.originalForm);
        },
        resetForm() {
            this.formFields = reactive({
                name: '',
                typeSelect: '',
                description: '',
                start_time: '',
                end_time: '',
                email: '',
                status: '',
                index_name: '',
            });
        },
        async fetchTaskData(id) {
            try {
                const response = await request({ method: 'get', url: `/admin/scheduled-task/${this.TaskId}` });
                const data = response.data;
                localStorage.setItem('taskData', JSON.stringify(data))
                this.formFields.name = data.name || "";
                this.formFields.typeSelect = this.serviceOptions.find(option => option.value === data.scheduled_type) || this.serviceOptions[0];
                this.formFields.start_time = data.start_time?.split(':').slice(0, 2).join(':') || "";
                this.formFields.end_time = data.end_time?.split(':').slice(0, 2).join(':') || "";
                this.formFields.description = data.description || "";
                this.formFields.email = data.email || "";
                this.formFields.index_name = data.index_name || "automatic";
                this.formFields.status = data.is_active ? "Active" : "InActive" || "";
                this.originalForm = { ...this.formFields };
            } catch (error) {
                console.error('Error fetching Task data:', error);
            }
        },

        validateStatus() {
            const status = this.formFields.status;
            if (!status) {
                this.formErrors.$errors.status = [this.$t('title.statusRequired')];
            } else {
                delete this.formErrors.$errors.status;
            }
        },

        validateName() {
            const name = this.formFields.name;
            if (!name || typeof name !== 'string') {
                this.formErrors.$errors.name = [this.$t('title.TaskNameRequired')];
            } else if (name.trim().length < 3) {
                this.formErrors.$errors.name = [this.$t('title.TaskNameMinLength')];
            } else {
                delete this.formErrors.$errors.name;
            }
        },

        validatescheduledtype() {
            const typeSelect = this.formFields.typeSelect;
            if (!typeSelect) {
                this.formErrors.$errors.typeSelect = [this.$t('title.frequencyRequired')];
            } else {
                delete this.formErrors.$errors.typeSelect;
            }
        },

        validateDescription() {
            const description = this.formFields.description;
            if (!description) {
                this.formErrors.$errors.description = [this.$t('title.descriptionRequired')];
            } else if (description.length < 10) {
                this.formErrors.$errors.description = [this.$t('title.descriptionMinLength')];
            } else {
                delete this.formErrors.$errors.description;
            }
        },

        validateEmail() {
            const email = this.formFields.email;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!email) {
                this.formErrors.$errors.email = [this.$t('title.emailRequired')];
            } else if (!emailRegex.test(email)) {
                this.formErrors.$errors.email = [this.$t('title.invalidEmail')];
            } else {
                delete this.formErrors.$errors.email;
            }
        },

        validateStartTime() {
            if (this.formFields.typeSelect && this.formFields.typeSelect.value === 'D') {
                delete this.formErrors.$errors.start_time;
                return;
            }

            if (!this.formFields.start_time) {
                this.formErrors.$errors.start_time = [this.$t('title.startTimeRequired')];
                return;
            }
        },

        validateEndTime() {
            // Skip validation for Daily type
            if (this.formFields.typeSelect && this.formFields.typeSelect.value === 'D') {
                delete this.formErrors.$errors.end_time;
                return;
            }

            if (!this.formFields.end_time) {
                this.formErrors.$errors.end_time = [this.$t('title.endTimeRequired')];
                return;
            }

            const startTime = this.formFields.start_time.split(':').map(Number);
            const endTime = this.formFields.end_time.split(':').map(Number);

            const startMinutes = startTime[0] * 60 + startTime[1];
            const endMinutes = endTime[0] * 60 + endTime[1];

            if (endMinutes <= startMinutes) {
                this.formErrors.$errors.end_time = [this.$t('title.endTimeGreaterThanStartTime')];
            } else {
                delete this.formErrors.$errors.end_time;
            }
        },

        reloadPage() {
            this.$router.push({ name: 'scheduledTasks' });
        },

        async onSubmit() {
            this.formErrors = new Error({});
            this.validateName();
            this.validatescheduledtype();
            this.validateDescription();
            this.validateEmail();
            this.validateStartTime();
            this.validateEndTime();
            this.validateStatus();
            const hasErrors = Object.keys(this.formErrors.$errors).length > 0;

            if (hasErrors) {
                this.formErrors.general = "Please fix the errors before submitting.";
                return;
            }
            const transformTime = time => time ? time.substring(0, 5) : '';
            const payload = {
                name: this.formFields.name,
                start_time: transformTime(this.formFields.start_time),
                end_time: transformTime(this.formFields.end_time),
                description: this.formFields.description,
                email: this.formFields.email,
                scheduled_type: this.formFields.typeSelect ? this.formFields.typeSelect.value : '',
                index_name: this.formFields.index_name || 'rakoon_notion',
                is_active: this.formFields.status === "InActive" ? 0 : 1

            };
            if (this.finalInsight) {
                this.formFields.description = this.finalInsight;
            }
            try {
                const response = await request({
                    method: 'put',
                    url: `admin/scheduled-task/${this.TaskId}`,
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json',   // Content type for JSON data
                    }
                });

                const data = response;
                if (response['message'] && response['message'].includes("successfull") || response['code'] == 200) {
                    this.showToast();
                    setTimeout(() => {
                        this.reloadPage();
                    }, 1500);
                } else {
                    throw new Error(data.message || 'Error submitting form');
                }
            } catch (error) {
                this.formErrors = new Error({});

                if (error?.data?.errors) {
                    const errors = error.data.errors;
                    this.formErrors.$errors.name = errors.name ? errors.name : '';
                    this.formErrors.$errors.typeSelect = errors.scheduled_type ? errors.scheduled_type : '';
                    this.formErrors.$errors.start_time = errors.start_time ? errors.start_time : '';
                    this.formErrors.$errors.general = "Please fix the errors and try again.";
                    return false;

                } else {

                    this.formErrors.general = "Something went wrong. Please try again.";
                }
            }
        },
        async evaluateInsight() {
            this.isEvaluating = true;
            try {
                const response = await request({
                    method: 'post',
                    url: '/improve-insight',
                    data: {
                        prompt: this.formFields.description,
                        index_name: this.formFields.index_name || 'rakoon_notion',
                        context: {
                            name: this.formFields.name,
                            scheduled_type: this.formFields.typeSelect?.value || this.formFields.typeSelect,
                            start_time: this.formFields.start_time,
                            end_time: this.formFields.end_time,
                            email: this.formFields.email,
                            status: (this.formFields.status && this.formFields.status.value !== undefined) ? this.formFields.status.value : this.formFields.status
                        }
                    }
                });
                console.log('response', response);
                // Handle cases where API returns code-fenced JSON inside improved_prompt
                let improved = response.improved_prompt;
                let suggestions = response.suggestions || [];
                if (typeof improved === 'string' && improved.includes('```')) {
                    const match = improved.match(/```[a-zA-Z]*\n([\s\S]*?)```/);
                    if (match && match[1]) {
                        try {
                            const parsed = JSON.parse(match[1]);
                            if (parsed && typeof parsed === 'object') {
                                if (parsed.improved_prompt) improved = parsed.improved_prompt;
                                if (Array.isArray(parsed.suggestions)) suggestions = parsed.suggestions;
                            }
                        } catch (e) {
                            // ignore parse error, fall back to raw string
                        }
                    }
                }
                this.suggestedInsight = improved;
                this.userScore = response.original_prompt_score || 3;
                this.suggestedScore = response.improved_prompt_score || 9;
                this.suggestions = suggestions;
                this.showSuggestion = true;
            } catch (e) {
                this.$bvToast.toast('Failed to improve insight. Please try again.', { variant: 'danger' });
            }
            this.isEvaluating = false;
        },
        keepOriginal() {
            this.finalInsight = this.formFields.description;
            this.showSuggestion = false;
        },
        acceptSuggestion() {
            this.finalInsight = this.suggestedInsight;
            this.formFields.description = this.suggestedInsight;
            this.userScore = this.suggestedScore;
            this.showSuggestion = false;
        },
        showToast() {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
                this.$t('title.dataUpdated')
            ]);
            // Create the title
            const vNodesTitle = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, this.$t('title.dataUpdatedTitle'))]
            );
            // Pass the VNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: 'success',
            });
        },

        onCancel() {
            this.$router.push({ name: 'scheduledTasks' });
        },
    },



    mounted() {
        const id = this.$route.params.id;
        this.TaskId = id;
        this.fetchTaskData(id);
    },


    watch: {
        'formFields.typeSelect'(newValue) {
            if (newValue.value === 'D') {
                this.formFields.end_time = ''; // Clear end_time when Daily is selected
                this.endTimeDisabled = true;  // Disable the field
            } else {
                this.endTimeDisabled = false; // Enable when not Daily
            }
        },
        formFields: {
            deep: true,
            handler() {
                this.checkForChanges();
            }
        }

    },
};
</script>
<style>
.vue__time-picker input.display-time {
    width: 100% !important;
}

.card:hover {
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.10) !important;
}

.card-header,
.card-body {
    padding: 0.5rem 0.75rem !important;
}

.keep-original-btn {
    background-color: #e3f2fd !important;
    border-color: #90caf9 !important;
    color: #1565c0 !important;
}

.keep-original-btn:hover,
.keep-original-btn:focus {
    background-color: #bbdefb !important;
    color: #0d47a1 !important;
}

@media (max-width: 767px) {
    .row.mb-3>.col-md-6 {
        margin-bottom: 0.5rem;
    }
}
</style>
